import { Button, ButtonProps } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { ReactNode } from 'react'

interface TMobileButton extends ButtonProps {
    startIcon: ReactNode
}

const MobileIconButton = ({ children, startIcon, ...rest }: TMobileButton) => {
    const screen = useScreenSize()

    const { isMobile } = screen
    return (
        <Button
            startIcon={startIcon}
            {...rest}
            sx={{
                ...rest.sx,
                ...(isMobile && {
                    [`& .MuiButton-startIcon`]: {
                        mx: (t) => t.spacing(0),
                    },
                }),
            }}
        >
            {!isMobile && children}
        </Button>
    )
}

export default MobileIconButton
